module.exports = __webpack_public_path__ + "media/images/icons/instagram-w-28c73ab3b511f2fd756e7d585ac5ebd5.svg";